import { render, staticRenderFns } from "./EditReportPeople.vue?vue&type=template&id=2e6f67bc"
import script from "./EditReportPeople.vue?vue&type=script&lang=js"
export * from "./EditReportPeople.vue?vue&type=script&lang=js"
import style0 from "./EditReportPeople.vue?vue&type=style&index=0&id=2e6f67bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports